<ng-container *ngIf="(dashboardDatas$ | async) as dashboardDatas">

  <div *ngIf="dashboardDatas.uxInteractions.sendCard.mode === 'edit'" class="send-cards-container"
    [formGroup]="fEmailToCard">

    <div appFlex="auto" class="p-8">

      <mat-form-field appFlex="auto" class="w-100-p h-100-p">

        <mat-label>Card</mat-label>
        <mat-select formControlName="cardTypeChoosed">
          <mat-select-trigger>
            <div appFlexLayout appFlexAlign="start center">
              <div appFlex class="tangoCard-picture">
                <img src="{{cardChoosed?.imageUrl}}" alt="{{cardChoosed?.name}}" />
              </div>
              <span appFlex class="tangoCard-name">
                {{cardChoosed?.name ? cardChoosed.name : ''}}
              </span>
            </div>
          </mat-select-trigger>

          <mat-option *ngFor="let card of cardList" [value]="card.utid" class="p-4">
            <div appFlexLayout appFlexAlign="start center" class="p-4">
              <img src="{{card && card.imageUrl}}" alt="{{card.name}}" class="tangoCard-picture-list" />
              <span appFlex="auto" class="tangoCard-name">{{card.name}} ({{card.currency}})</span>
            </div>
          </mat-option>
        </mat-select>

      </mat-form-field>

      <mat-form-field appFlex style="margin-top:6px;" class="p-4 mt-8" *ngIf="cardChoosed">
        <mat-label>Card amount</mat-label>
        <input matInput type="number" formControlName="amountChoosed" min="0">
        <span matSuffix>{{cardChoosed.currency}}</span>
        <mat-error *ngIf="fEmailToCard.controls.amountChoosed.invalid">Invalid Amount!</mat-error>
      </mat-form-field>
      <button [disabled]="cardChoosed.faceValue !== 'none'" *ngIf="fEmailToCard.controls.amountChoosed?.value" matSuffix
        mat-icon-button aria-label="Clear"
        (click)="fEmailToCard.controls.amountChoosed.patchValue('', {emitEvent: false})">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <ng-container *ngIf="cardChoosed">

      <div appFlex="auto" class="fuse-card" appFlexLayout="column" id="receipt" style="min-height:200px;"
        formArrayName="recipients">

        <div appFlex appFlexLayout="row" *ngIf="!importMode">
          <div appFlex="grow">

          </div>
          <div appFlex="auto" class="p-8">
            <button mat-stroked-button (click)="importMode = true">Import</button>
          </div>
        </div>

        <div appFlex class="p-4" appFlexLayout="column" style="overflow: auto;" *ngIf="importMode">
          <div>
            <mat-form-field class="w-100-p">
              <mat-label>Batch import</mat-label>
              <textarea matInput [formControl]="fEmailsToImport" style="min-height:100px"></textarea>
            </mat-form-field>
          </div>
          <div appFlex>
            <span appFlex="grow"></span>
            <button mat-stroked-button (click)="convertToEmails()">Convert</button>
          </div>
        </div>

        <div appFlex class="p-4" appFlexLayout="column" style="overflow: auto;" *ngIf="!importMode">

          <div appFlex appFlexLayout="row"
            *ngFor="let _ of frecipients.controls; index as i;let first = first;let last = last;">
            <ng-container [formGroupName]="i">

              <div appFlex="80" class="p-2">
                <mat-form-field class="w-100-p">
                  <mat-label>Email</mat-label>
                  <input type="email" matInput formControlName="email">
                </mat-form-field>
              </div>

              <div appFlex="20" class="p-2">
                <mat-form-field class="w-100-p">
                  <mat-label>Amount</mat-label>
                  <input type="number" matInput formControlName="amount">
                </mat-form-field>
              </div>

              <div appFlex="10" appFlexLayout="row" appFlexAlign="end center">
                <button *ngIf="!first" [class]="{'lonesomeDelete': !last}" mat-icon-button (click)="removeReceipt(i)"><i
                    class="mdi mdi-delete-outline"></i></button>
                <button *ngIf="last" mat-icon-button (click)="addAReceipt()"><i
                    class="mdi mdi-plus-circle-outline"></i></button>
              </div>

            </ng-container>
          </div>

        </div>

      </div>

      <div appFlex="auto" class="fuse-card mt-8" appFlexLayout="column" id="message" formGroupName="mailGroup">

        <div class="p-8">
          <div class="h1">Message:</div>
        </div>

        <div appFlex class="p-4">
          <mat-form-field class="w-100-p">
            <mat-label>Subject</mat-label>
            <input type="text" matInput formControlName="subject">
          </mat-form-field>
        </div>

        <div appFlex class="p-4">
          <mat-form-field class="w-100-p">
            <mat-label>Message</mat-label>
            <textarea matInput formControlName="message" style="min-height:200px"></textarea>
          </mat-form-field>
        </div>

        <div appFlex="10" class="p-4" appFlexLayout="row" id="sendToolBar">
          <span appFlex="grow"></span>
          <button mat-raised-button (click)="reviewCards()">Send !</button>
        </div>

      </div>

      <span appFlex="grow"></span>

    </ng-container>

  </div>

  <div class="send-cards-container"
    *ngIf="dashboardDatas.uxInteractions.sendCard.mode === 'review' || dashboardDatas.uxInteractions.sendCard.mode === 'send'">

    <div appFlex="auto" appFlexLayout="row">
      <div appFlex class="grow">Sending
        <b>{{dashboardDatas.uxInteractions.sendCard.nbDone}}/{{sendToPayload.length}}</b> TangoCards
      </div>
      <button [disabled]="dashboardDatas.uxInteractions.sendCard.isSending" mat-button (click)="setState('edit')"
        class="ml-4">Start again</button>
      <button
        [disabled]="dashboardDatas.uxInteractions.sendCard.isSending || dashboardDatas.uxInteractions.sendCard.isSent"
        mat-stroked-button (click)="doSendCards()" class="ml-4">Send Now / process</button>
    </div>

    <div appFlex="auto" appFlexLayout="column" class="mt-8" style="overflow: auto;">
      <div appFlex="auto" appFlexLayout="column" *ngFor="let payload of dashboardDatas.data.cardsToSend" class="p-4">

        <div appFlex class="message-box" [ngClass]="{
             'warning': (payload.isSending),
             'error': (!payload.isSending && payload.error),
             'success': (!payload.isSending && !payload.error && payload.done)
             }" appFlexLayout="row">
          <div appFlex="80">
            To: {{payload.email}}
          </div>
          <div appFlex="20">
            {{payload.amount | currency}} {{cardChoosed?.currency || '[No currency?]'}}
          </div>
          <div appFlex="auto">
            [{{payload.done}}]
          </div>
        </div>

        <div *ngIf="payload.error" appFlex="auto" style="overflow: auto; height: 150px;">
          <pre>{{payload.result|json}}</pre>
        </div>

      </div>
    </div>

    <div appFlex="grow" appFlexLayout="column">
      <div appFlex="grow"></div>
      <div appFlex appFlexLayout="row">
        <div appFlex class="grow"></div>
        <button [disabled]="dashboardDatas.uxInteractions.sendCard.isSending" mat-button (click)="setState('edit')"
          class="ml-4">Start again</button>
        <button
          [disabled]="dashboardDatas.uxInteractions.sendCard.isSending || dashboardDatas.uxInteractions.sendCard.isSent"
          mat-stroked-button (click)="doSendCards()" class="ml-4">Send Now / process</button>
      </div>
    </div>

  </div>

</ng-container>